import { Link } from 'react-router-dom';

const scrollTo = (id: string) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

const PROVIDERS = [
  { name: 'Wise', link: 'https://wise.com/invite/dic/arlindad30' },
  { name: 'Remitly', link: 'https://www.remitly.com/r/3ccs1e2j' },
  { name: 'Western Union', link: 'https://ssqt.co/mQNlL2e' },
  { name: 'WorldRemit', link: 'https://worldremit.com' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/28a02ba018e540cb808856dcffc9a7b1/bf08d36ac370f16f9e9d390506ce9cf0.png"
              alt="RemesasVE"
              className="h-9 w-auto object-contain mb-5 brightness-0 invert"
            />
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs mb-5">
              Ayudamos a venezolanos en el exterior a encontrar la forma más económica de enviar dinero a Venezuela. Comparación gratuita y actualizada diariamente.
            </p>
            <div className="flex flex-wrap gap-2 mb-5">
              {['🇺🇸 EE.UU.', '🇪🇸 España', '🇨🇱 Chile', '🇨🇴 Colombia'].map((c) => (
                <span key={c} className="bg-slate-800 border border-slate-700 rounded-full px-3 py-1 text-xs text-slate-400">{c}</span>
              ))}
            </div>
            <a href="mailto:info@remesasve.com" className="inline-flex items-center gap-2 text-slate-400 hover:text-green-400 text-sm transition-colors">
              <i className="ri-mail-line" />
              info@remesasve.com
            </a>
          </div>

          {/* Navegación */}
          <div>
            <h4 className="text-xs font-bold text-slate-500 uppercase tracking-widest mb-5">
              <a href="#comparar">Navegación</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Comparar Servicios', id: 'comparar' },
                { label: 'Cómo Funciona', id: 'como-funciona' },
                { label: 'Preguntas Frecuentes', id: 'faq' },
                { label: 'Alertas de Tasas', id: 'suscribir' },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="text-slate-400 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal + Servicios */}
          <div>
            <h4 className="text-xs font-bold text-slate-500 uppercase tracking-widest mb-5">
              <a href="#comparar">Información</a>
            </h4>
            <ul className="flex flex-col gap-3 mb-6">
              <li><Link to="/sobre-nosotros" className="text-slate-400 hover:text-white text-sm transition-colors cursor-pointer">Sobre Nosotros</Link></li>
              <li><Link to="/privacidad" className="text-slate-400 hover:text-white text-sm transition-colors cursor-pointer">Política de Privacidad</Link></li>
              <li><Link to="/terminos" className="text-slate-400 hover:text-white text-sm transition-colors cursor-pointer">Términos y Condiciones</Link></li>
            </ul>
            <h4 className="text-xs font-bold text-slate-500 uppercase tracking-widest mb-3">Servicios</h4>
            <ul className="flex flex-col gap-2">
              {PROVIDERS.map((p) => (
                <li key={p.name}>
                  <a
                    href={p.link}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-slate-400 hover:text-green-400 text-sm transition-colors cursor-pointer"
                  >
                    {p.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-xs">
            &copy; {year} RemesasVE.com · Todos los derechos reservados
          </p>
          <p className="text-slate-600 text-xs text-center md:text-right max-w-md">
            Las tasas son referenciales. RemesasVE no procesa transferencias. Verifica antes de enviar. Podemos recibir comisiones por referidos.
          </p>
        </div>
      </div>
    </footer>
  );
}
